import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FormControl, FormControlLabel, Radio, RadioGroup } from '../atom'

interface IList {
  label: string
}

interface Props {
  list?: IList[]
  onChange?: (value: string) => void
  value?: string
}

const Wrapper = styled.div`
  display: flex;
  gap: 24px;
  background-color: #f5f5f5;
  padding-left: 16px;
  border-radius: 8px;
  width: fit-content;
`

const RowRadioButton = (props: Props) => {
  const { list, onChange, value } = props
  const [selectedValue, setSelectedValue] = useState('0')

  useEffect(() => {
    if (value) setSelectedValue(value)
  }, [value])

  const handleRadioButton = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value

    setSelectedValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  const controlProps = (item: string) => ({
    checked: selectedValue === item,
    onChange: () => handleRadioButton,
    value: item,
    name: 'color-radio-button',
    inputProps: { 'aria-label': item },
  })

  return (
    <Wrapper>
      <FormControl>
        <RadioGroup row value={selectedValue} onChange={handleRadioButton}>
          {list?.map((item, index) => (
            <FormControlLabel
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
              control={
                <Radio
                  {...controlProps(`${index}`)}
                  sx={{
                    '&.Mui-checked': {
                      color: '#57C9A7',
                    },
                  }}
                  size="small"
                />
              }
              label={item.label}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Wrapper>
  )
}

export default RowRadioButton
